import React from "react";

export const PageHero = ({ eyebrow, title, subtitle, children, dark = true }) => (
  <section className={`${dark ? "bg-taven-black text-white" : "bg-white"} relative overflow-hidden`} data-testid="page-hero">
    {dark && <div className="absolute inset-0 opacity-25" style={{ backgroundImage: "radial-gradient(circle at 15% 30%, rgba(197,160,89,0.35), transparent 40%), radial-gradient(circle at 85% 70%, rgba(242,101,34,0.3), transparent 45%)" }} />}
    <div className="relative px-4 md:px-8 lg:px-12 mx-auto max-w-7xl py-14 md:py-20">
      {eyebrow && <span className="text-xs font-bold uppercase tracking-[0.3em] text-taven-gold">{eyebrow}</span>}
      <h1 className="text-4xl sm:text-5xl font-black tracking-tighter font-display mt-2 max-w-3xl">{title}</h1>
      {subtitle && <p className={`mt-4 max-w-2xl text-base md:text-lg ${dark ? "text-white/70" : "text-muted-foreground"}`}>{subtitle}</p>}
      {children && <div className="mt-7 flex flex-wrap gap-3">{children}</div>}
    </div>
  </section>
);

export const Field = ({ label, name, value, onChange, type = "text", required, placeholder, options, textarea }) => {
  const base = "w-full bg-white border border-black/15 focus:border-taven-gold outline-none px-4 py-3 text-sm";
  return (
    <label className="block">
      <span className="text-xs font-bold uppercase tracking-wider text-black/70">{label}{required && <span className="text-taven-red"> *</span>}</span>
      <div className="mt-1.5">
        {options ? (
          <select data-testid={`field-${name}`} required={required} value={value} onChange={(e) => onChange(name, e.target.value)} className={base}>
            <option value="">Select...</option>
            {options.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        ) : textarea ? (
          <textarea data-testid={`field-${name}`} required={required} rows={4} placeholder={placeholder} value={value} onChange={(e) => onChange(name, e.target.value)} className={base} />
        ) : (
          <input data-testid={`field-${name}`} required={required} type={type} placeholder={placeholder} value={value} onChange={(e) => onChange(name, e.target.value)} className={base} />
        )}
      </div>
    </label>
  );
};

export const SuccessCard = ({ title, text, testid }) => (
  <div className="bg-white border-2 border-taven-gold p-10 text-center" data-testid={testid || "form-success"}>
    <div className="w-14 h-14 rounded-full bg-taven-gold/15 flex items-center justify-center mx-auto"><span className="text-taven-gold text-2xl">✓</span></div>
    <h3 className="text-xl font-black font-display mt-4">{title}</h3>
    <p className="text-muted-foreground mt-2">{text}</p>
  </div>
);
